











































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { clamp } from 'ramda'

export default defineComponent({
  name: 'BaseInputNumber',

  props: {
    value: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: 'normal',
      validator: (val: string) => {
        return ['normal', 'free', 'lg'].includes(val)
      },
    },
    step: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    maxLength: {
      type: Number,
      default: Infinity,
    },
    precision: {
      type: Number,
      default: 0,
      validator: (val: number) =>
        val >= 0 && val === Number.parseInt(`${val}`, 10),
    },
    block: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    contronlPosition: {
      type: String,
      default: 'default',
      validator: (val: string) => ['default', 'right'].includes(val),
    },
  },

  setup(props, { emit }) {
    const inputEl = ref<HTMLInputElement | null>(null)

    const inputType = computed(() => (isFocus.value ? 'text' : 'number'))

    const check = (newValue: number) => {
      if (isNaN(newValue)) {
        if (inputEl.value) {
          inputEl.value.value = props.value.toString()
        }
        return
      }
      newValue = clamp(props.min, props.max, newValue)
      if (props.precision !== undefined) {
        newValue = Number(newValue.toFixed(props.precision))
      }
      if (newValue.toString().length > props.maxLength) {
        const maxValue = Math.pow(10, props.maxLength) - 1
        if (newValue > maxValue) {
          newValue = maxValue
        } else {
          newValue = Number(newValue.toString().slice(0, props.maxLength))
        }
      }
      if (newValue === props.value && inputEl.value) {
        inputEl.value.value = newValue.toString()
      }
      if (newValue !== props.value) {
        emit('change', newValue)
      }
    }

    const onFocus = (event: InputEvent) => {
      isFocus.value = true
      if (inputEl.value) {
        inputEl.value.type = 'text'
        const valueLength = props.value.toString().length
        inputEl.value.setSelectionRange(valueLength, valueLength)
        emit('focus', event)
      }
    }

    const onDecrease = () => {
      check(props.value - props.step)
      emit('decrease')
    }

    const onIncrease = () => {
      check(props.value + props.step)
      emit('increase')
    }

    const showQuantitySelect = () => {
      
    }

    const isFocus = ref(false)

    return {
      inputEl,
      isFocus,
      inputType,
      check,
      onFocus,
      onDecrease,
      onIncrease,
      showQuantitySelect
    }
  },
})
